function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SaleListingTypeKeys, SaleMethod, SaleMethodKeys } from '@domain-group/fe-allhomes-library/lib/node';
import { MultiValueSearchQueryField } from '../multi-value-search-query-field';
import { parseSlugs } from '../../utils/parse-slugs';
export class SaleMethodsFilter extends MultiValueSearchQueryField {
  get validListingTypes() {
    return [...SaleListingTypeKeys, 'DEVELOPMENTS_RESIDENTIAL'];
  }
  constructor(searchOptions, values) {
    super(searchOptions, Object.values(SaleMethod), values, [...SaleMethodKeys]);
    _defineProperty(this, "urlSlug", SaleMethodsFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new SaleMethodsFilter(searchOptions, parseSlugs(SaleMethod, q[SaleMethodsFilter.urlSlug]));
  }
}
_defineProperty(SaleMethodsFilter, "urlSlug", 'methods');